<template>
  <div class="draeger-reviews push-up-double">
    <h3 class="h2 color-accent">Reviews</h3>
    <div class="loader loading" v-if="loading"></div>
    <div class="draeger-reviews--carousel" ref="carousel">
      <div class="draeger-reviews--review" :data-key="key" v-for="(review, key) in reviews" :key="review.id">
        <div class="review--author">
          <img :src="review.authorImage" />
          <p style="text-transform: capitalize;"><strong>{{ review.author }}</strong></p>
        </div>
        <div class="review--rating"><span v-for="i in 5" :key="i"><i :class="['fas fa-star', { 'color-accent': i <= review.rating, 'color-grey-light-alt': i > review.rating }]"></i>&nbsp;</span></div>
        <div class="review--content">
          <p>{{ review.data }}</p>
        </div>

        
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Flickity from 'flickity'
export default {
  props: ['uberallId'],
  data() {
      return {
          loading: true,
          $api: null,
          reviews: [],
          key: 0,
          flickity: null,
      }
  },
  methods: {
      getReviews() {
        if(!this.uberallId) return;
        this.loading = true
        return this.$api.get(`/locations/${this.uberallId}/reviews`).then((response) => {
            this.reviews = response.data
            this.loading = false
        })
      },
      mountCarousel() {
        if(!this.reviews.length) return;
        this.flickity = new Flickity(this.$refs.carousel, {
          cellSelector: '.draeger-reviews--review',
          pageDots: false,

        })
      }
  },
  created() {
    this.$api = axios.create({
      baseURL: '/wp-json/uberall/v1/',
      headers: { 'X-WP-Nonce': window.DRAEGER.nonce },
      withCredentials: true,
    })
  },
  mounted() {
    this.getReviews().then(() => this.mountCarousel())
  }
}
</script>

<style lang="scss">
.draeger-reviews--review {
  padding: 1rem;
  border: 2px solid #EAEEF0;
  margin: 0 0.5rem;
  width: 300px;
  text-align: center;

  .review--author {

    img {
      max-width: 44px;
      margin: 0 0 0.5rem;
    }
  }

  .review--rating {
    margin: 0.5rem 0;
  }

}
</style> 